import { useEffect } from "react"
import styles from "./Skeleton.module.css"

const Skeleton = ({ type = "rect", width, height, borderRadius = 0, style }) => {

    return (
        <>
            {type === "circle" &&
                <div className={styles.circle} style={{ minHeight: height, minWidth: width, maxHeight: height, maxWidth: width, borderRadius: width, ...style }}>
                </div>
            }
            {type === "rect" &&
                <div className={styles.rect} style={{ height: height, width: width, borderRadius: borderRadius, ...style }}>
                </div>
            }
        </>

    )

}

export default Skeleton
